import { createTheme, type MantineColorsTuple } from "@mantine/core";

const tkanaPurple: MantineColorsTuple = [
  "#f3f1fe",
  "#e3dffa",
  "#c5bdf4",
  "#a599ed",
  "#8878e6",
  "#6e5de0",
  "#3a2d8e",
  "#32277c",
  "#2a216a",
  "#221b58",
];

// Custom theme configuration
export const theme = createTheme({
  primaryColor: "tkanaPurple",
  fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
  colors: {
    tkanaPurple,
  },
  components: {
    Stepper: {
      defaultProps: {
        color: "tkanaPurple",
      },
      styles: {
        stepLabel: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
        stepDescription: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: "lg",
        padding: "lg",
      },
    },
    Button: {
      defaultProps: {
        color: "tkanaPurple", // Fallback color, overridden by styles
      },
      styles: {
        root: {
          borderRadius: 20,
          minWidth: 100,
          fontWeight: 500,
          transition: "all 0.2s ease",
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Text: {
      styles: {
        root: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Title: {
      styles: {
        root: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Input: {
      styles: {
        input: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Textarea: {
      styles: {
        input: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Select: {
      styles: {
        input: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
        item: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Menu: {
      styles: {
        item: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
    Modal: {
      styles: {
        title: {
          fontFamily: "Rubik, Poppins, Tajawal, sans-serif",
        },
      },
    },
  },
});
